$.fn.stratis_megamenu = function (settings) {

    // MEGAMENU by @Sereja Smerechevskiy
    /*
    Accessible Markup (Defaults):
        - nav: class="main-menu__nav" role="navigation" aria-label="Principale"
        - ul: class="main-menu__list level-#" role="menu"

        Menu dropdown wrapper:
            - div: class="main-menu__dropdown"
            - div: class="main-menu__container"

        Menu items markups:
            - li: class="main-menu__item" role="menuitem"
            - li: class="main-menu__item is-current" role="menuitem"
            - li: class="main-menu__item is-active" role="menuitem"
            - li: class="main-menu__item" role="menuitem"

        - button: class="menu-main__action-btn" aria-expanded="false" aria-controls="relationship-#ID"
     */

    settings = $.extend({
        menuActiveClass: 'is-active',
        searchSelector: '',
        mobileSearch: true,
        openByLink: false,
        collapseWidth: 1280
    }, settings);

    // Add ARIA role to menubar and menu items
    $(this).attr('role', 'menubar').find('li').attr('role', 'menuitem');

    var top_level_links = $('.level-1 > li > a');
    var sublevel_links = $('.level-2 li a');
    var mobileCollapse = $('.main-menu__action-btn');
    var collapsePanel = mobileCollapse.next();

    // Set tabIndex to -1 so that top_level_links can't receive focus until menu is open
    $(top_level_links).next('ul').attr({
        'aria-hidden': 'true',
        'role': 'menu'
    }).find('a').attr('tabindex', -1);

    $(top_level_links).each(function () {
       if ($(this).next().length > 0) {

           var $this = $(this);
           var $menuitem = $this.parent();
           var $dropdown = $this.next();

           addAllyControls($this, $dropdown);

           $this.on('click', function (e) {
               e.preventDefault();
               manageExpandedState($this, $dropdown);
               manageMenuItemState($menuitem, $dropdown);
           });
       }
    });

    if (settings.openByLink === false) {
        $(sublevel_links).each(function () {
            if ($(this).next('ul').length > 0) {

                var $this = $(this);
                var $actionButton = $('<button type="button" class="'+ settings.triggerButtonClass +'">Déplier le menu</button>').insertAfter($this);
                var $menuitem = $this.parent();
                var $dropdown = $this.next();

                addAllyControls($actionButton, $dropdown);

                $actionButton.on('click', function (e) {
                    e.preventDefault();
                    manageExpandedState($actionButton, $dropdown);
                    manageMenuItemState($menuitem, $dropdown);
                });
            }
        });
    }

    else {
        $(sublevel_links).each(function () {
            if ($(this).next('ul').length > 0) {
                var $this = $(this);
                var $menuitem = $this.parent();
                var $dropdown = $this.next();

                addAllyControls($this, $dropdown);

                $this.on('click', function (e) {
                    e.preventDefault();
                    manageExpandedState($this, $dropdown);
                    manageMenuItemState($menuitem, $dropdown);
                });
            }
        })
    }

    mobileCollapse.on('click', function () {

        var $menuitem = $(this).parent();

        manageExpandedState(mobileCollapse, collapsePanel);
        manageMenuItemState($menuitem, collapsePanel);
    });

    $(window).on("resize load", function () {
        if ($(window).width() < settings.collapseWidth) {
            mobileCollapse.attr('tabindex', 0);
            addAllyControls(mobileCollapse, collapsePanel);
        }

        else {
            mobileCollapse.attr('tabindex', -1);
            removeAllyControls(mobileCollapse, collapsePanel);
        }
    });

    function addAllyControls(item, relationship) {

        var ariaControlsId = Math.round(new Date().getTime() + Math.random() * 100);

        if (!$(item).attr('type')) {
            $(item).attr('role', 'button');
        }

        $(relationship)
            .attr('aria-controls', 'relationship-' + ariaControlsId)
            .attr('aria-hidden', 'true');

        $(item).attr({
            "aria-expanded": "false",
            "aria-haspopup": "true",
            "aria-controls": "relationship-"+ ariaControlsId
        });
    }

    function removeAllyControls(item, relationship) {
        $(item)
            .removeAttr('role')
            .removeAttr('aria-expanded')
            .removeAttr('aria-haspopup')
            .removeAttr('aria-controls');
        $(relationship)
            .removeAttr('aria-hidden')
            .removeAttr('aria-controls');
    }

    function manageMenuItemState(menuitem, relationship) {
        if ($(menuitem).hasClass('is-active')) {
            $(menuitem).removeClass('is-active');
            setClosedMenuState(relationship);
        } else {
            $(menuitem).addClass('is-active');
            setOpenMenuState(relationship);
        }
    }

    function setOpenMenuState(menu) {
        $(menu).attr('aria-hidden', 'false');
        $(menu).find(' > li > a').attr('tabindex', 0);
    }

    function setClosedMenuState(menu) {
        $(menu).attr('aria-hidden', 'true');
        $(menu).find(' > li > a').attr('tabindex', -1);
    }

    function manageExpandedState(item) {

        var expandedState = $(item).attr('aria-expanded');
        console.log(expandedState);
        if (expandedState === 'true') {
            $(item).attr('aria-expanded', 'false');
        } else {
            $(item).attr('aria-expanded', 'true');
        }
    }

    // TODO : need to realise this functions
    // function addClickBehavior() {
    //
    //     var $this = $(this);
    //     var $menuitem = $this.parent();
    //     var $dropdown = $this.next();
    //
    //     addAllyControls($this, $dropdown);
    //
    //     $this.on('click', function (e) {
    //         e.preventDefault();
    //         manageExpandedState($this, $dropdown);
    //         manageMenuItemState($menuitem, $dropdown);
    //     });
    // }

}

$('.main-menu__nav').stratis_megamenu({
    openByLink: true
});

